import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";

export const DeleteBankResponseSchema = BaseResponseSchema.extend({
    data: z.null()
});

export type DeleteBankResponse = z.infer<typeof DeleteBankResponseSchema>;
